import { normalizeQuery } from 'utils/url/utils';

export function composeSearchQuery(search: Record<string, string | number>) {
  const searchQuery = new URLSearchParams(normalizeQuery(search));
  return searchQuery.toString();
}
